import {
    MDBBtn,
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBCheckbox
}
    from 'mdb-react-ui-kit';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
// import logImg from "../../components/images/Easy-MembrLogo.png";
import logImg from "../../components/images/easybook.png";
import PasswordStrengthChecker from "../../components/PasswordValidator";
import ReCAPTCHA from "react-google-recaptcha";
import { ClassesLoginImg } from '../../components/images/ClassAssets';
import { createGBussinessInfo, numberSignUp } from '../../services/classApiServices.js';
// import jwt_decode from "jwt-decode";
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CardBody, Col, Row } from "reactstrap";
import { isEmail, isEmpty } from "../../validators/helper.js";
// import logImg from "./../components/images/GymLogo.png";
import logBg from "../../components/images/loginBg.png";
import PageError from "../PageError";

function ClassesSignup({ setToken }) {
    const [phnumber, setPhnumber] = useState("");
    const [userExists, setUserExists] = useState(false);
    const [verror, setVerror] = useState('')
    const [error, setError] = useState({});
    const [verify, setVerify] = useState(false)
    const [otp, setOtp] = useState("");
    const [notp, setNotp] = useState("");
    const [captchaValue, setCaptchaValue] = useState(false);
    const [merror, setSError] = useState();
    const [strongPassword, setstrongPassword] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const [signupForm, setsignupForm] = useState({
        firstname: "",
        lastname: "",
        number: "6281639094",
        email: "",
        password: "",
        confirmp: "",
        tempcaptcha: "",
    });
    const [capSitekey, setCapSiteKey] = useState("")
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const planId = params.get('id');
    const [domain, setDomain] = useState("")
    // console.log("planid :- " + planid + " " + " " + "planname :- " + planname);
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);

    useEffect(() => {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const domain = urlObj.hostname;
        // console.log(domain);
        setDomain(domain)
    }, []);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };

    function verifyCaptchaCallback(resp) {
        console.log("Respons for captcha");
        console.log(resp);
        if (!resp) {
            setCaptchaValue(false);
        }
        else {
            console.log("true");
            setCaptchaValue(true);
        }
    }

    function updateForm(value) {
        return setsignupForm((prev) => {
            return { ...prev, ...value };
        });
    }

    async function serverSumit(updates) {
        let saverep = await createGBussinessInfo(updates);
        console.log(saverep);
        if (saverep === "false") {
            setApiError(true)
            return;
        }
        let jsOBj = await saverep.json();
        console.log(saverep.status);
        if (saverep.status !== 200) {
            setSError("Email already exits in the system!");
        } else {
            console.log(jsOBj);
            console.log(jsOBj.token);
            setToken(jsOBj.token);
            await setUserSession(jsOBj.userInfo);
            navigate("/classdashboard");
        }
    }


    function responseGmail(resp) {
        console.log("response from gmail..");
        console.log(resp);
        let data = jwtDecode(resp.credential);
        console.log(data);
        const updates = {
            email: data.email,
            password: "d3fault",
            through: "google",
            number: signupForm.number,
        };
        serverSumit(updates);
    }

    useEffect(() => {
        let capSite_id = "6LfQZGglAAAAAPPUCjiIsnyCvmGisjTTowbcFP3_"
        let CLIENT_ID = "68288337026-6p3096b5r2ukcpvbvggtrgsinp72eegd.apps.googleusercontent.com";
        if (domain == "easymembr.zencruz.com" || domain == "easyemebr-beta.zencruz.com") {
            const frontEndEnvData = localStorage.getItem("frontEndEnvData");
            CLIENT_ID = frontEndEnvData ? JSON.parse(frontEndEnvData)?.clientid : "102702637040-eau4e3o86jeoorqtveosi9fggnkduc7j.apps.googleusercontent.com";
            capSite_id = frontEndEnvData ? JSON.parse(frontEndEnvData)?.capSiteid : "6LcbvooqAAAAADsZ5lZdBiF1dt_ipQQdlTnppmwX"
        }
        // console.log(CLIENT_ID);
        setCapSiteKey(capSite_id)

        /* global google*/
        google.accounts.id.initialize({
            client_id: CLIENT_ID + "",
            callback: responseGmail,
            context: "signup",
        });

        google.accounts.id.renderButton(document.getElementById("signinDiv"),
            { theme: "outline", size: "large" }
        );
    }, [domain]);

    const navigate = useNavigate();
    let validateForm = (e) => {
        e.stopPropagation();
        console.log("Validating form...");
        let errors = {};
        console.log(signupForm.name);

        if (isEmpty(signupForm.email)) {
            errors.email = "Email can't be blank";
        } else if (!isEmail(signupForm.email)) {
            errors.email = "Please enter valid email";
        }
        if (isEmpty(signupForm.password)) {
            errors.passwordstrong = "Password can't be blank";
        }
        else if (!strongPassword.istrong) {
            errors.passwordstrong = "Please enter strong password!";
        }
        else if (signupForm.password !== signupForm.confirmp) {
            errors.confirmp = "Password not matching";
        }
        else if (!captchaValue) {
            errors.tempcaptcha = "Please check the captcha"
        }
        if (isEmpty(signupForm.number)) {
            errors.number = "Field can't be empty.";
        } else if (!isEmpty(signupForm.number) && !isValidPhoneNumber(signupForm.number)) {
            errors.number = "Please enter valid Phone Number";
        }
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };

    function setUserSession(userInfo) {
        localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
    }


    function setPasswordStatus(tflag) {
        setstrongPassword(tflag);
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const updates = {
            firstname: signupForm.firstname,
            lastname: signupForm.lastname,
            email: signupForm.email,
            password: signupForm.password,
            through: "signup",
            number: signupForm.number,
        };
        console.log(updates, '99999999999999999999999');

        let noerrors = validateForm(e);
        console.log(noerrors);
        if (noerrors === true) {
            let saverep = await createGBussinessInfo(updates);
            if (saverep === "false") {
                setApiError(true)
                return;
            }
            let jsOBj = await saverep.json();
            console.log(saverep.status);
            if (saverep.status !== 200) {
                console.log("Email already exits in the system!");
            }
            else {
                console.log(jsOBj);
                console.log(jsOBj.token);
                setToken(jsOBj.token);
                await setUserSession(jsOBj.userInfo);
                navigate("/classdashboard");
                localStorage.removeItem("number")
            }
        } else {
            setError(noerrors);
        }
    };

    const otpfield = async (e) => {
        e.preventDefault();
        if (!isValidPhoneNumber(phnumber)) {
            setError("Please enter valid contact number!");
        }
        else {
            const response = await numberSignUp({ phone: phnumber });
            let resData = await response.json();
            // console.log(resData);
            if (resData.status !== 200) {
                setError(resData.status === 400 ? "Please try again." : "Number already exits in the system!")
            }
            else {
                setError("OTP Sent Sucessfully");
                setUserExists(true);
                setNotp(resData.otp);
                setsignupForm({
                    ...signupForm,
                    number: phnumber
                })
            }


        }
    }

    function updateLoginUser(value) {
        // e.preventDefault();
        setPhnumber(value);
        setOtp("");
        setUserExists(false);
        setError("");
    }

    const ovalidation = async (e) => {
        e.preventDefault();
        console.log(phnumber);
        console.log(otp, notp);

        if (otp !== notp) {
            setVerror("Invalid OTP.Please try again.");
        }
        else {
            setVerror("OTP verified Sucessfully");
            setVerify(true)
            localStorage.setItem("number", JSON.stringify(phnumber));
            // if (planId) {
            // navigate(`/billingsubscriptionplan?id=${planId}&value=${planTimePeriod}`);
            // } else {
            // navigate(`/signup`);
            // }
        }

    }
    return (
        <MDBContainer fluid className='p-0' >

            <div className='d-flex align-items-center'>


                <div style={{ width: "650px" }} >
                    <div className="p-5 p-sm-0 d-flex align-items-center justify-content-center flex-column w-100 h-100vh sm-h-100vh mobileclasslogin ">
                        <MDBCard className='mx-2 mb-3 p-5 custom-shadow rounded-5 w-70 mob-p-3' style={{ background: 'hsla(0, 0%, 100%, 0.8)', backdropFilter: 'blur(30px)' }}>
                            <div className='d-flex flex-row mt-2'>
                                <img src={logImg} alt="" className='gymlogo1 p-0 m-0' style={{ width: "250px" }} />
                            </div>

                            <h5 className="my-3" style={{ letterSpacing: '1px' }}>Create your account</h5>

                            {/* <MDBInput wrapperClass='mb-4 border-success' label='Your Mobile Number.*' id='formControlLg' type='text' size="lg" /> */}
                            <label className="form-label mt-2">Your Mobile No.<span className="text-danger">*</span></label>
                            <div className="d-flex align-items-center mb-2">
                                <PhoneInput
                                    className="form-control w-80"
                                    defaultCountry="IN"
                                    placeholder="Mobile Number"
                                    value={phnumber}
                                    disabled={userExists}
                                    onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                    onChange={(value) => updateLoginUser(value)}
                                />
                                {(userExists === true ? (!verify ? <MDBBtn style={{ whiteSpace: "nowrap" }} className="btn-primary ms-2 px-2 w-30 text-capitalize" onClick={(e) => otpfield(e)}>Resend OTP</MDBBtn> : <MDBIcon fas icon="check-circle" color="success" size="xl" className="ms-3" />)
                                    : <MDBBtn style={{ whiteSpace: "nowrap" }} className="btn-primary ms-2 px-2 w-30" onClick={(e) => otpfield(e)}>Get OTP</MDBBtn>)}
                            </div>

                            {error.number && (
                                <>
                                    <p className="clr-red">{error.number}</p>
                                </>
                            )}
                            <div style={(verror === "OTP Sent Sucessfully" || verror === "OTP verified Sucessfully") ? { color: "green" } : { color: "red" }}>{verror}</div>

                            {userExists && verror !== "OTP verified Sucessfully" && (
                                <div >
                                    <label className="form-label">Enter OTP<span className="text-danger">*</span></label>
                                    <div className="d-flex mb-2">
                                        <input type="text"
                                            className="form-control w-80" placeholder="Enter OTP"
                                            value={otp}
                                            disabled={verify}
                                            onChange={(e) => setOtp(e.target.value)}
                                            required />
                                        {!verify && userExists === true && <MDBBtn style={{ whiteSpace: "nowrap" }} className="btn-primary ms-2 px-2 w-30 text-capitalize" onClick={(e) => ovalidation(e)}>Verify</MDBBtn>}
                                    </div></div>
                            )}
                            <MDBRow>
                                <MDBCol sm={12} lg={6} md={6} className='mb-2'>
                                    <div>
                                        <label className="form-label">
                                            First Name<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="First Name"
                                            onChange={(e) => updateForm({ firstname: e.target.value })} value={signupForm.firstname}
                                        />
                                    </div>
                                    {error.name && (
                                        <>
                                            <p className="clr-red">{error.name}</p>
                                        </>
                                    )}
                                    {/* <MDBInput wrapperClass='mb-4' label='First Name.*' id='formControlLg' type='text' size="lg" onChange={(e) => updateForm({ firstname: e.target.value })} value={signupForm.firstname} /> */}
                                </MDBCol>
                                <MDBCol sm={12} lg={6} md={6}>
                                    <div>
                                        <label className="form-label">
                                            Last Name<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="First Name"
                                            onChange={(e) => updateForm({ lastname: e.target.value })} value={signupForm.lastname}
                                        />
                                    </div>
                                    {error.name && (
                                        <>
                                            <p className="clr-red">{error.name}</p>
                                        </>
                                    )}
                                    {/* <MDBInput wrapperClass='mb-4' label='Last Name.*' id='formControlLg' type='text' size="lg" onChange={(e) => updateForm({ lastname: e.target.value })} value={signupForm.lastname} /> */}
                                </MDBCol>
                            </MDBRow>
                            <div className='mb-2'>
                                <label className="form-label">
                                    Email<span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Your Email Address"
                                    onChange={(e) => updateForm({ email: e.target.value })} value={signupForm.email}
                                />
                            </div>
                            {error.email && (
                                <>
                                    <p className="clr-red">{error.email}</p>
                                </>
                            )}
                            {/* <MDBInput wrapperClass='mb-4' label='Your Email.*' id='formControlLg' type='email' size="lg" onChange={(e) => updateForm({ email: e.target.value })} value={signupForm.email} /> */}
                            <div className="IconContainer mb-2" >
                                {/* <MDBInput label='Password' id='formControlLg' type={isPasswordVisible ? "text" : "password"} size="lg" />
                                <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} /> */}
                                <PasswordStrengthChecker
                                    setPasswordInput={updateForm}
                                    setPasswordStatus={setPasswordStatus}
                                />
                                {error.passwordstrong && (
                                    <>
                                        <p className="clr-red">{error.passwordstrong}</p>
                                    </>
                                )}
                            </div>
                            <div className="IconContainer mb-3">

                                <label className="form-label">Confirm Password<span className="text-danger">*</span></label>
                                <div className="IconContainer">
                                    <input
                                        type={isPasswordVisible ? "text" : "password"}
                                        className="form-control" placeholder="Confirm Password"
                                        onChange={(e) => updateForm({ confirmp: e.target.value })} value={signupForm.confirmp}
                                        required />
                                    <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} />

                                </div>


                                {/* <MDBInput label='Confirm Password' id='formControlLg' type={isPasswordVisible ? "text" : "password"} size="lg" onChange={(e) => updateForm({ confirmp: e.target.value })} value={signupForm.confirmp} />
                                <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} /> */}
                            </div>
                            <div className="mb-3">
                                <ReCAPTCHA
                                    className="mt-3 w-100 recapthca"
                                    sitekey={"6LfQZGglAAAAAPPUCjiIsnyCvmGisjTTowbcFP3_"}
                                    onChange={
                                        // (e) =>
                                        verifyCaptchaCallback
                                        // ({ captcha: e.target.value })
                                    }
                                    theme="light"
                                    size="large"
                                />
                            </div>
                            <MDBBtn className="mb-4 px-5 w-100" size='lg' onClick={submitHandler}>Signup</MDBBtn>


                            {/* <MDBBtn className="mb-4 w-100" size="lg" >
                                <MDBIcon fab icon="google" className="mx-2" />
                                Sign in with google
                            </MDBBtn> */}
                            <div className="text-center">
                                <p className="pb-lg-2" style={{ color: '#393f81' }}>
                                    Already have an account?
                                    <Link to="/classlogin" className="p-0" style={{ color: '#393f81' }}> Login</Link>
                                </p>
                            </div>



                        </MDBCard>
                        <div className='d-flex flex-row justify-content-start'>
                            <a href="#!" className="p-0 text-muted me-1">
                                &copy; {new Date().getFullYear()}
                            </a>
                            <a href="#!" className="p-0 text-muted">Zencruz.</a>
                        </div>


                    </div>

                </div>



                <div style={{ width: "calc(100vw - 650px)" }}>
                    <MDBCardImage src={ClassesLoginImg} alt="login form" className='rounded-0 w-100 h-100vh' style={{ objectFit: "cover" }} />
                </div>

            </div>

        </MDBContainer>
    );
}

export default ClassesSignup